import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { ButtonGroupOption } from 'src/app/shared/atomic/atoms/button-group/button-group.component';
import { PILL_TYPES } from 'src/app/ui/pill/pill.component';

export interface MortgageTabOption<T> extends ButtonGroupOption<T> {
	newFlag?: boolean;
}

@Component({
	selector: 'app-mortgage-tabs',
	templateUrl: './mortgage-tabs.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MortgageTabsComponent<O> {
	@Input() tabs: MortgageTabOption<O>[];
	@Input() selectedTab: MortgageTabOption<unknown>;
	@Output() tabSelected = new EventEmitter<MortgageTabOption<unknown>>();
	public pillTypes = PILL_TYPES;

	updateSelectedTab(tab) {
		this.tabSelected.emit(tab);
	}
}
